export const reports_url = document.getElementById('reports_url').value;
export const user_company = document.getElementById('user_company').value
export const localStorageKeyPrefix = `dashboard2__${reports_url}__${user_company}__`
